import { z } from "zod";
import { ActivityType, ActivityPriority, ActivityOutcome } from "../api/crmApi";

export const activitySchema = z.object({
    type: z.nativeEnum(ActivityType, { errorMap: () => ({ message: "Type is required" }) }),
    subject: z
        .string()
        .min(1, "Subject is required")
        .max(200, "Subject must be less than 200 characters"),
    body: z.string().optional(),
    priority: z.nativeEnum(ActivityPriority, {
        errorMap: () => ({ message: "Priority is required" }),
    }),
    dueDate: z.string().min(1, "Due date is required"),
    dueTime: z.string().min(1, "Due time is required"),
    contactId: z.string().min(1, "Contact is required"),
    assignedTo: z.string().min(1, "Assignee is required"),
    outcome: z.nativeEnum(ActivityOutcome).optional(),
    dealId: z.string().optional(),
    companyId: z.string().optional(),
    location: z.string().max(300, "Location must be 300 characters or less").optional(),
    duration: z.number().int().positive("Duration must be a positive number").optional(),
});

export type ActivityFormValues = z.infer<typeof activitySchema>;
